import { createContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // Ensure REACT_APP_API_URL is defined in your .env file
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api/"; // Fallback URL for safety
  const [authLoading, setAuthLoading] = useState(true);



  // Login Function
  const login = async (values) => {
    setAuthLoading(true); // Indicate loading state during login attempt
    try {
      const res = await axios.post(`${baseUrl}auth/login`, values);
      const userData = res.data.user;
      const token = res.data.token;

      setUser(userData);
      localStorage.setItem("token", token);
      setAuthLoading(false);
      return { success: true, user: userData }; // Return user data on success
    } catch (error) {
      setAuthLoading(false);
      return {
        success: false,
        message: error.response?.data?.message || "Login failed!",
      };
    }
  };

  const googleLogin = async () => {
    const client_id =
      "199792176197-071rrrjpkc6hg5ir060nhjnk9m6t5es2.apps.googleusercontent.com";
    const redirect_uri = `https://web.booze247.co.uk/login`;
    const scope = "openid email profile";
    const response_type = "code";
    const auth_url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}&access_type=offline&prompt=consent`;
    window.location.href = auth_url;
  };

  const facebookLogin = async () => {
    const client_id = "9767826913345415"; // Replace with your Facebook App ID
    const redirect_uri = `https://web.booze247.co.uk/facebook-callback`;
    const scope = "email public_profile";
    const auth_url = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${client_id}&redirect_uri=${redirect_uri}&scope=${scope}`;
    window.location.href = auth_url;
  }

  // Register Function
  const register = async (payload) => {
    // Renamed 'values' to 'payload' for clarity, as it comes from Register.js
    // The 'payload' from Register.js is already in the format { fullname, phone, email, password }
    // So, we can use it directly.
    setAuthLoading(true); // Indicate loading state during registration attempt
    try {
      const res = await axios.post(`${baseUrl}auth/register`, payload); // Pass payload directly
      const userData = res.data.user;
      const token = res.data.token;

      setUser(userData);
      localStorage.setItem("token", token);
      setAuthLoading(false);
      return { success: true, user: userData }; // Return user data on success
    } catch (error) {
      setAuthLoading(false);
      return {
        success: false,
        message: error.response?.data?.message || "Registration failed!",
      };
    }
  };

  // Persist user on refresh
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .get(`${baseUrl}auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setUser(res.data.user);
        })
        .catch(() => {
          // Token might be invalid or expired
          localStorage.removeItem("token");
          setUser(null); // Clear user state
        })
        .finally(() => {
          setAuthLoading(false);
        });
    } else {
      setAuthLoading(false); // No token found, auth check complete
    }
  }, [baseUrl]); // baseUrl dependency is fine, though typically this runs once on mount

  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
    // Optionally, you might want to redirect to login page or update authLoading
    // setAuthLoading(false); // Or true then false if there's an async logout process
  };

  const authInfo = {
    user,
    setUser, // Exposing setUser might be powerful but can lead to inconsistent states if not handled carefully
    login,
    register,
    logout,
    authLoading,
    googleLogin,
    facebookLogin
    // setAuthLoading, // Generally, setAuthLoading should be managed internally by the provider
  };

  return (
    <AuthContext.Provider value={authInfo}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
export { AuthContext };
